import { useEffect, useState } from "react";
import MainContainer from "../../components/partials/maincontainer";
import { IconButton } from "../../components/partials/btn";
import DataTable from "../../components/tables";
// import InviteModal from "../../components/modals/invitemodal";
import SuccessModal from "../../components/modals/successmodal";
import { useUsersStore } from "../../data/stores/loggerStore";
import { FlowSelectDropdown } from "../../components/partials/select";
import { dataStatus } from "../../utils/types";
import { SearchInput } from "../../components/partials/inputs";
import useAuthStore from "../../data/stores/authStore";
import InviteModal from "../../components/modals/invitemodal";

const FocalPerson = () => {
  const [activeTab, setActiveTab] = useState("view-all"),
    [setupStatus, setSetUpStatus] = useState(""),
    [modal, setModal] = useState(""),
    [search, setSearch] = useState(""),
    { getDynamicLogger } = useUsersStore(),
    { allDataFocalPerson }: any = useUsersStore(),
    { user } = useAuthStore();

  useEffect(() => {
    getDynamicLogger({}, "allDataFocalPerson");
    getDynamicLogger({}, "newlyUploadedDataFocalPerson");
  }, []);

  return (
    <div>
      <MainContainer>
        <div className="bg-transparent main-border main-shadow rounded-lg">
          <div
            style={{
              borderBottom: "1px solid #D7E2EC",
            }}
            className="py-5"
          >
            <div className="w-full px-5 flex justify-between items-center">
              <div>
                <div className="flex gap-2 items-center">
                  <h4 className="text-lg font-medium text-sec">
                    Focal Persons
                  </h4>
                  <button className="h-6 px-5 bg-[#E6F3FE] rounded-lg text-xs font-medium text-[#2070B8]">
                    {allDataFocalPerson?.totalDocs}{" "}
                    {allDataFocalPerson?.totalDocs > 1 ? "Invites" : "Invite"}
                  </button>
                </div>
                <p className="text-sm text-es-gray-100 mt-1 font-normal">
                  Keep track of focal person and their assessment updates
                </p>
              </div>
              <div className="flex gap-5 items-center">
                <span className="hidden">
                  <IconButton
                    icon="humbleicons:download"
                    text="Bulk Invite"
                    onClick={() => setModal("bulk-upload")}
                  />
                </span>
                <IconButton
                  onClick={() => setModal("invite")}
                  icon="material-symbols:add"
                  color="white"
                  text="New Invite"
                  bg="#2070B8"
                />
              </div>
            </div>

            <p className="text-sm mt-3 px-5 text-red-500 font-bold">
              NB: For your utility to be displayed on map, the status for all
              departments should be "Assessment Complete"
            </p>
          </div>

          <div
            style={{
              borderBottom: "1px solid #D7E2EC",
            }}
            className="h-20 w-full px-5 flex justify-between items-center"
          >
            <div className="inline-flex h-11 rounded-lg main-border overflow-hidden">
              <button
                className={`px-6  text-sm font-medium ${
                  activeTab === "view-all"
                    ? "bg-[#F9FAFB] text-gray-800"
                    : "bg-transparent text-gray-600 hover:text-gray-800"
                }`}
                onClick={() => setActiveTab("view-all")}
              >
                View all
              </button>
              <div className="h-full w-px bg-[#d0d5dd]" />
              <button
                className={`px-6 text-sm font-medium ${
                  activeTab === "newly-uploaded"
                    ? "bg-[#F9FAFB] text-gray-800"
                    : "bg-transparent text-gray-600 hover:text-gray-800"
                }`}
                onClick={() => setActiveTab("newly-uploaded")}
              >
                Newly Uploaded
              </button>
            </div>
            <div className="flex gap-4 items-center">
              <SearchInput
                value={search}
                onChange={(e) => {
                  setSearch(e);
                }}
              />
              <FlowSelectDropdown
                options={[
                  { title: "All" },
                  ...dataStatus?.map((it) => {
                    return { title: it };
                  }),
                ]}
                onChange={(d: any) => {
                  setSetUpStatus(d?.title === "All" ? "" : d?.title);
                }}
              />
              {/* <IconButton icon="famicons:filter" text="Filter" /> */}
            </div>
          </div>
          <DataTable
            usecase={activeTab}
            setupStatus={setupStatus}
            search={search}
            isFocalPerson={user?._id}
          />
        </div>
      </MainContainer>
      {modal === "invite" && (
        <>
          <InviteModal
            handleModal={() => setModal("success")}
            handleClose={() => setModal("")}
          />
        </>
      )}
      {modal === "success" && (
        <SuccessModal
          btnText="Return to Home"
          page="/"
          title="Focal Person Invitation Sent"
          desc="This invitation has been sent successfully. Department will be able to complete assessment."
        />
      )}
    </div>
  );
};

export default FocalPerson;
